import React, { useEffect, useRef, useState, useLayoutEffect, useContext } from "react";
import "./DividendCalculator.scss";
import Dropdown from "react-bootstrap/Dropdown";
import FormControl from "react-bootstrap/FormControl";
import { Col, Container, Form, InputGroup, Row } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faHexagonCheck } from "@fortawesome/pro-solid-svg-icons";
import { faChevronRight, faChevronDown } from "@fortawesome/pro-solid-svg-icons";
import { faSearch } from "@fortawesome/pro-regular-svg-icons";
import { faCalculator } from "@fortawesome/pro-solid-svg-icons";
import LiveTickerBar from "../../../components/live-ticker-bar/liveTickerBar";
import * as wjcGrid from "@grapecity/wijmo.react.grid";
import * as wjGrid from "@grapecity/wijmo.grid";
import * as ReactDOMServer from "react-dom/server";

import * as am5 from "@amcharts/amcharts5";
import * as am5xy from "@amcharts/amcharts5/xy";
import am5themes_Animated from "@amcharts/amcharts5/themes/Animated";
import { ThemeContext } from "../../../context/theme-context";
import { InputText } from "primereact/inputtext";
import { Calendar } from "primereact/calendar";
import moment from "moment/moment";
import { addLocale } from "primereact/api";
import Button from "react-bootstrap/Button";
import BlinkerBar from "../../../components/blinker";
import { useTranslation } from "react-i18next";
import { DashboardServiceApi, Configuration } from "../../../../src/services/yieldcalculator";
import { APIControl } from "../../../helpers/APIControl";
import { useSelector } from "react-redux";
export default function DividendCalculator() {
  const dashboardServiceApi = new DashboardServiceApi(new Configuration({ basePath: process.env.REACT_APP_YIELDCALCULATOR_API_BASE_PATH }), undefined, APIControl(process.env.REACT_APP_YIELDCALCULATOR_API_BASE_PATH));

  const { t, i18n } = useTranslation();
  const [gridData, setGridData] = useState([]);
  const [gridColumns, setGridColumns] = useState([]);
  const [sourceSelectItem, setSourceSelectItem] = useState([]);
  const [securitySelectItem, setSecuritySelectItem] = useState([]);

  const [chartData, setChartData] = useState([]);
  const [theme, setTheme] = useState("dark"); // ['dark', 'light'
  const currentTheme = useContext(ThemeContext).theme;
  const [firstDate, setfirstDate] = useState();
  const [lastDate, setlastDate] = useState();
  const [initialInvestment, setInitialInvestment] = useState("");
  const [startingQuantity, setStartingQuantity] = useState("");
  const [dropdownAllOption, setDropdownAllOption] = useState([]);
  const [dropdownFilterOption, setDropdownFilterOption] = useState([]);
  const [dropdownSearchValue, setDropdownSearchValue] = useState("");
  const language = i18n.language;
  const token = useSelector((state) => state.auth?.token);

  addLocale("tr", {
    firstDayOfWeek: 1,
    showMonthAfterYear: true,
    dayNames: ["Pazartesi", "Salı", "Çarşamba", "Perşembe", "Cuma", "Cumartesi", "Pazar"],
    dayNamesShort: ["pzt", "sal", "çar", "per", "cum", "cmt", "paz"],
    dayNamesMin: ["P", "S", "Ç", "P", "C", "C", "P"],
    monthNames: ["Ocak", "Şubat", "Mart", "Nisan", "Mayıs", "Haziran", "Temmuz", "Ağustos", "Eylül", "Ekim", "Kasım", "Aralık"],
    monthNamesShort: ["ock", "şbt", "mrt", "nsn", "mays", "hzr", "tmz", "ağs", "eyl", "ekm", "ksm", "arl"],
    today: "Bugün",
    clear: "Temizle",
  });

  const columns = [
    { binding: "name", header: "Veriler", align: "left", isContentHtml: true, width: 300 },
    { binding: "ratesAndPrices", header: "Oran ve Fiyatlar", align: "center" },
    { binding: "amountsAndamounts", header: "Tutar ve Miktarlar", align: "center" },
    { binding: "benchmarkData", header: "Kıstas Verileri", align: "center" },
  ];

  const sourceItems = [
    { id: "BIST100", name: "BIST100" },
    { id: "BIST030", name: "BIST030" },
    { id: "BIST050", name: "BIST050" },
  ];

  const dummyChartdata = [
    {
      Points: [
        {
          Date: "2022-10-25",
          Value: 100,
        },
        {
          Date: "2022-10-26",
          Value: 110,
        },
        {
          Date: "2022-10-27",
          Value: 200,
        },
        {
          Date: "2022-10-30",
          Value: 120,
        },
        {
          Date: "2022-10-31",
          Value: 300,
        },
        {
          Date: "2022-11-01",
          Value: 220,
        },
        {
          Date: "2022-11-02",
          Value: 200,
        },
        {
          Date: "2022-11-03",
          Value: 90,
        },
        {
          Date: "2022-11-07",
          Value: 150,
        },
        {
          Date: "2022-11-08",
          Value: 150,
        },
        {
          Date: "2022-11-09",
          Value: 150,
        },
        {
          Date: "2022-11-10",
          Value: 150,
        },
        {
          Date: "2022-11-11",
          Value: 150,
        },
        {
          Date: "2022-11-12",
          Value: 150,
        },
        {
          Date: "2022-11-13",
          Value: 150,
        },
      ],
    },
    {
      Points: [
        {
          Date: "2022-10-25",
          Value: 100,
        },
        {
          Date: "2022-10-26",
          Value: 150,
        },
        {
          Date: "2022-10-27",
          Value: 200,
        },
        {
          Date: "2022-10-30",
          Value: 120,
        },
        {
          Date: "2022-10-31",
          Value: 250,
        },
        {
          Date: "2022-11-01",
          Value: 220,
        },
        {
          Date: "2022-11-02",
          Value: 200,
        },
        {
          Date: "2022-11-03",
          Value: 90,
        },
        {
          Date: "2022-11-06",
          Value: 150,
        },
      ],
    },
  ];
  const dummySecurityOptions = [
    {
      Code: "DOAS",
      UniqueCode: "DOAS:IS",
      Name: "DOĞUŞ OTOMOTİV",
    },
    {
      Code: "ENJSA",
      UniqueCode: "ENJSA:IS",
      Name: "ENERJİSA ENERJİ",
    },
    {
      Code: "MAVI",
      UniqueCode: "MAVI:IS",
      Name: "MAVİ GİYİM",
    },
    {
      Code: "AKBNK",
      UniqueCode: "AKBNK:IS",
      Name: "AKBANK",
    },
    {
      Code: "ENKAI",
      UniqueCode: "ENKAI:IS",
      Name: "ENKA İNŞAAT",
    },
    {
      Code: "EREGL",
      UniqueCode: "EREGL:IS",
      Name: "EREĞLİ DEMİR ÇELİK",
    },
    {
      Code: "FROTO",
      UniqueCode: "FROTO:IS",
      Name: "FORD OTOSAN",
    },
    {
      Code: "GARAN",
      UniqueCode: "GARAN:IS",
      Name: "GARANTİ BANKASI",
    },
    {
      Code: "SOKM",
      UniqueCode: "SOKM:IS",
      Name: "ŞOK MARKETLER TİCARET",
    },
    {
      Code: "HALKB",
      UniqueCode: "HALKB:IS",
      Name: "HALK BANKASI",
    },
    {
      Code: "ISCTR",
      UniqueCode: "ISCTR:IS",
      Name: "İŞ BANKASI (C)",
    },
    {
      Code: "KCHOL",
      UniqueCode: "KCHOL:IS",
      Name: "KOÇ HOLDİNG",
    },
    {
      Code: "KORDS",
      UniqueCode: "KORDS:IS",
      Name: "KORDSA TEKNİK TEKSTİL",
    },
    {
      Code: "KRDMD",
      UniqueCode: "KRDMD:IS",
      Name: "KARDEMİR (D)",
    },
    {
      Code: "MGROS",
      UniqueCode: "MGROS:IS",
      Name: "MİGROS",
    },
    {
      Code: "OTKAR",
      UniqueCode: "OTKAR:IS",
      Name: "OTOKAR",
    },
    {
      Code: "PETKM",
      UniqueCode: "PETKM:IS",
      Name: "PETKİM",
    },
    {
      Code: "SAHOL",
      UniqueCode: "SAHOL:IS",
      Name: "SABANCI HOLDİNG",
    },
    {
      Code: "SISE",
      UniqueCode: "SISE:IS",
      Name: "ŞİŞE CAM",
    },
    {
      Code: "TAVHL",
      UniqueCode: "TAVHL:IS",
      Name: "TAV HAVALİMANLARI",
    },
    {
      Code: "TCELL",
      UniqueCode: "TCELL:IS",
      Name: "TURKCELL",
    },
    {
      Code: "THYAO",
      UniqueCode: "THYAO:IS",
      Name: "TÜRK HAVA YOLLARI",
    },
    {
      Code: "TKFEN",
      UniqueCode: "TKFEN:IS",
      Name: "TEKFEN HOLDİNG",
    },
    {
      Code: "TOASO",
      UniqueCode: "TOASO:IS",
      Name: "TOFAŞ OTOMOBİL FAB.",
    },
    {
      Code: "TSKB",
      UniqueCode: "TSKB:IS",
      Name: "T.S.K.B.",
    },
    {
      Code: "TTKOM",
      UniqueCode: "TTKOM:IS",
      Name: "TÜRK TELEKOM",
    },
    {
      Code: "TTRAK",
      UniqueCode: "TTRAK:IS",
      Name: "TÜRK TRAKTÖR",
    },
    {
      Code: "TUPRS",
      UniqueCode: "TUPRS:IS",
      Name: "TÜPRAŞ",
    },
    {
      Code: "ULKER",
      UniqueCode: "ULKER:IS",
      Name: "ÜLKER",
    },
    {
      Code: "VAKBN",
      UniqueCode: "VAKBN:IS",
      Name: "T. VAKIFLAR BANKASI",
    },
    {
      Code: "YKBNK",
      UniqueCode: "YKBNK:IS",
      Name: "YAPI VE KREDİ BANKASI",
    },
    {
      Code: "ARCLK",
      UniqueCode: "ARCLK:IS",
      Name: "ARÇELİK",
    },
    {
      Code: "ASELS",
      UniqueCode: "ASELS:IS",
      Name: "ASELSAN",
    },
    {
      Code: "BIMAS",
      UniqueCode: "BIMAS:IS",
      Name: "BİM BİRLEŞİK MAĞAZALAR",
    },
    {
      Code: "KOZAL",
      UniqueCode: "KOZAL:IS",
      Name: "KOZA ALTIN İŞLETMELERİ",
    },
    {
      Code: "BIZIM",
      UniqueCode: "BIZIM:IS",
      Name: "BİZİM TOPTAN SATIŞ MAĞAZALARI",
    },
    {
      Code: "PGSUS",
      UniqueCode: "PGSUS:IS",
      Name: "PEGASUS HAVA TAŞIMACILIĞI",
    },
    {
      Code: "AEFES",
      UniqueCode: "AEFES:IS",
      Name: "ANADOLU EFES BİRACILIK",
    },
    {
      Code: "CCOLA",
      UniqueCode: "CCOLA:IS",
      Name: "COCA COLA İÇECEK",
    },
  ];
  useState(() => {
    setChartData(dummyChartdata);
    setDropdownAllOption(dummySecurityOptions);
    setDropdownFilterOption(dummySecurityOptions);
  }, []);

  useEffect(() => {
    setGridData(getData());
    setGridColumns(columns);
    setSourceSelectItem(sourceItems[0]);
    setSecuritySelectItem(dummySecurityOptions[0]);
    setTheme(currentTheme);
    const currentDate = new Date();
    const oneYearAgo = new Date(currentDate);
    oneYearAgo.setFullYear(currentDate.getFullYear() - 1);
    setfirstDate(oneYearAgo);
    setlastDate(new Date());
    getSharesSecurityOptions();
  }, []);

  //#region Chart Settings & Create Series

  useLayoutEffect(() => {
    var root = am5.Root.new("chartdiv");

    root.setThemes([am5themes_Animated.new(root)]);

    var chart = root.container.children.push(
      am5xy.XYChart.new(root, {
        panY: false,
        wheelY: "zoomX",
        layout: root.verticalLayout,
        maxTooltipDistance: 0,
      })
    );

    const valueRenderer = am5xy.AxisRendererY.new(root, {});

    const valueTooltip = am5.Tooltip.new(root, {});
    valueTooltip.get("background").setAll({
      fill: chart.get("colors").getIndex(0),
    });

    valueRenderer.labels.template.adapters.add("text", (text, target) => {
      if (text) {
        return "$" + text + ".0";
      }
    });

    valueRenderer.labels.template.setAll({
      fill: theme === "dark" ? am5.color("#fff") : am5.color("#231f20"),
      tooltip: am5.Tooltip.new(root, {}),
      minGridDistance: 50,
      stroke: "#eb0505",
      color: theme === "dark" ? am5.color("#626262") : am5.color("#E4E4E4"),
    });

    var yAxis = chart.yAxes.push(
      am5xy.ValueAxis.new(root, {
        extraTooltipPrecision: 1,
        renderer: valueRenderer,
        labels: {
          stroke: theme == "dark" ? am5.color("#fff") : am5.color("#E4E4E4"),
        },
      })
    );

    yAxis.get("renderer").grid.template.setAll({
      strokeOpacity: 1,
      stroke: theme === "dark" ? am5.color("#fff") : am5.color("#E4E4E4"),
      strokeDasharray: [4, 4],
    });

    yAxis.get("renderer").labels.template.setAll({
      oversizedBehavior: "wrap",
      // maxWidth: 250,
      textAlign: "center",
      fontSize: 12,
      fontFamily: "Roboto-Medium",
      fill: theme === "dark" ? am5.color("#fff") : am5.color("#231f20"),
    });

    let axisRendererX = am5xy.AxisRendererX.new(root, {
      minGridDistance: 50,
      fill: theme === "dark" ? am5.color("#626262") : am5.color("#231f20"),
    });

    axisRendererX.labels.template.setAll({
      fill: theme === "dark" ? am5.color("#fff") : am5.color("#231f20"),
    });
    let xAxis = chart.xAxes.push(
      am5xy.DateAxis.new(root, {
        maxDeviation: 0.1,
        groupData: false,
        baseInterval: {
          timeUnit: "day",
          count: 1,
        },
        labels: {
          stroke: theme === "dark" ? am5.color("#626262") : am5.color("#E4E4E4"),
        },
        renderer: axisRendererX,
        tooltip: am5.Tooltip.new(root, {
          dateFormatter: "dd/MM/yyyy",
        }),
      })
    );

    xAxis.get("renderer").labels.template.setAll({
      oversizedBehavior: "wrap",
      // maxWidth: 250,
      textAlign: "center",
      fontSize: 12,
      fontFamily: "Roboto-Medium",
      fill: theme == "dark" ? am5.color("#fff") : am5.color("#231F20"),
      tooltipDateFormat: "dd/MM/yyyy",
      opacity: 0,
    });

    xAxis.get("renderer").grid.template.setAll({
      strokeOpacity: 0,
      stroke: theme === "dark" ? am5.color("#626262") : am5.color("#E4E4E4"),
      strokeDasharray: [4, 4],
    });

    let chartDataClone = chartData;

    chartDataClone[0].Points.forEach((item) => {
      item.Date = new Date(item.Date).getTime();
    });
    chartDataClone[1].Points.forEach((item) => {
      item.Date = new Date(item.Date).getTime();
    });

    chart.series.clear();

    chartDataClone.forEach((item, index) => {
      createSeries("test " + index, "Value", chart, root, xAxis, yAxis, item.Points);
    });

    return () => {
      root.dispose();
    };
  }, []);

  const createSeries = (name, field, chart, root, xAxis, yAxis, data) => {
    var series = chart.series.push(
      am5xy.LineSeries.new(root, {
        name: name,
        minBulletDistance: 10,
        xAxis: xAxis,
        yAxis: yAxis,
        valueYField: "Value",
        valueXField: "Date",
        tooltip: am5.Tooltip.new(root, {
          pointerOrientation: "horizontal",
          labelText: "{valueY}",
        }),
      })
    );

    let tooltip = am5.Tooltip.new(root, {
      getFillFromSprite: false,
      labelText: "[bold]{name}[/]: {valueY}",
    });

    tooltip.get("background").setAll({
      fill: am5.color(0xffffff),
      fillOpacity: 0.8,
    });

    series.set("tooltip", tooltip);
    series.strokes.template.setAll({
      strokeWidth: 3,
      templateField: "strokeSettings",
      color: theme === "dark" ? am5.color("#626262") : am5.color("#E4E4E4"),
    });

    series.data.setAll(data);
    var cursor = chart.set(
      "cursor",
      am5xy.XYCursor.new(root, {
        xAxis: xAxis,
      })
    );
    cursor.lineY.set("visible", false);
  };
  //#endregion Chart Settings & Create Series

  const getData = () => {
    let data = [
      { name: "Dönem Başı Fiyat", ratesAndPrices: "-", amountsAndamounts: 4, benchmarkData: 56 },
      { name: "Dönem Sonu Fiyat", ratesAndPrices: "-", amountsAndamounts: 5, benchmarkData: 56 },
      { name: "Başlangıç Yatırımı", ratesAndPrices: "-", amountsAndamounts: 100.0, benchmarkData: 56 },
      {
        name: "Bedelsiz Sermaye Artırımı",
        ratesAndPrices: "50%",
        amountsAndamounts: 25000,
        benchmarkData: 56,
        childsItem: [
          {
            name: "Bedelsiz Sermaye Artırımı 1",
            ratesAndPrices: "-",
            amountsAndamounts: "-",
            benchmarkData: "-",
          },
          {
            name: "Bedelsiz Sermaye Artırımı 2",
            ratesAndPrices: "-",
            amountsAndamounts: "-",
            benchmarkData: "-",
          },
        ],
      },
      {
        name: "Bedelli Sermaye Artırımı",
        ratesAndPrices: "-",
        amountsAndamounts: 12500,
        benchmarkData: 56,
        childsItem: [
          {
            name: "Bedelli Sermaye Artırımı 1",
            ratesAndPrices: 45.5,
            amountsAndamounts: 3.12,
            benchmarkData: 56,
          },
          {
            name: "Bedelli Sermaye Artırımı 2",
            ratesAndPrices: 45.5,
            amountsAndamounts: 3.12,
            benchmarkData: 56,
          },
        ],
      },
      {
        name: "Hisse Başı Net Temettü (TL)",
        ratesAndPrices: 0.5,
        amountsAndamounts: 12500,
        benchmarkData: 56,
        childsItem: [
          {
            name: "Hisse Başı Net Temettü (TL) 1",
            ratesAndPrices: 45.5,
            amountsAndamounts: 3.12,
            benchmarkData: 56,
          },
          {
            name: "Hisse Başı Net Temettü (TL) 2",
            ratesAndPrices: 45.5,
            amountsAndamounts: 3.12,
            benchmarkData: 56,
          },
        ],
      },
      { name: "Yeniden Yatırılan Temettü ile Ek Adet", ratesAndPrices: "-", amountsAndamounts: 2941, benchmarkData: "-" },
      { name: "Dönem Sonu Toplam Adet", ratesAndPrices: "-", amountsAndamounts: 250000, benchmarkData: "-" },
      { name: "Dönem Sonu Toplam Tutar", ratesAndPrices: "-", amountsAndamounts: 5000, benchmarkData: "-" },
    ];
    return data;
  };

  const changeValue = (item) => {
    setSourceSelectItem(item);
  };

  const changeSecurityValue = (item) => {
    setSecuritySelectItem(item);
    setDropdownSearchValue("");
    setDropdownFilterOption(dropdownAllOption);
  };

  const handleSearchChange = (e) => {
    const searchValue = e.target.value;
    setDropdownSearchValue(searchValue);
    const filteredOptionsClone = dropdownAllOption.filter((option) => option.Name.toLowerCase().includes(searchValue.toLowerCase()) || option.UniqueCode.toLowerCase().includes(searchValue.toLowerCase()));
    setDropdownFilterOption(filteredOptionsClone);
  };

  //#region Grid Settings

  const initializeGrid = (flex) => {
    flex.columnHeaders.rows.defaultSize = 62;

    flex.formatItem.addHandler((s, e) => {
      if (e.panel === s.cells) {
        var item = s.rows[e.row].dataItem;
        if (e.col == 0) {
          if (item.childsItem) {
            e.cell.className = e.cell.className + " collapseCell";
            if (e.cell.innerHTML.indexOf("wj-glyph-down-right") !== -1) {
              e.cell.innerHTML =
                '<button class="wj-btn wj-btn-glyph wj-elem-collapse" type="button" tabindex="-1" aria-label="Toggle Group" aria-expanded="false">' +
                ReactDOMServer.renderToString(<FontAwesomeIcon className="text-align-right float-right" style={{ cursor: "pointer" }} icon={faChevronRight} />) +
                '<span class="openTreeRow">' +
                e.cell.innerText +
                "</span> </button>";
            } else {
              e.cell.innerHTML =
                '<button class="wj-btn wj-btn-glyph wj-elem-collapse" type="button" tabindex="-1" aria-label="Toggle Group" aria-expanded="false">' +
                ReactDOMServer.renderToString(<FontAwesomeIcon className="text-align-right float-right" style={{ cursor: "pointer" }} icon={faChevronDown} />) +
                "<span>" +
                e.cell.innerText +
                "</span></button>";
            }
          }
        }
      }

      if (e.panel === s.columnFooters) {
        e.cell.parentElement.className = "wj-row redFooter";
        // if (true) {
        //     e.cell.parentElement.className = "wj-row redFooter"
        // }
        // else {
        //     e.cell.parentElement.className = "wj-row greenFooter"
        // }
      }
    });
    flex.columnFooters.rows.push(new wjGrid.GroupRow({ name: "GETİRİ", ratesAndPrices: "-", amountsAndamounts: "%321", benchmarkData: "%32" }));
  };
  //#endregion Grid Settings

  //#region

  const selectedDate = (event) => {
    try {
      // console.log("selectedDate: ", event);

      const date = moment(event.value).format("DD/MM/YYYY");
      if (date) {
        setfirstDate(event.value);
        // console.log("setfirstDate: ", date);
      } else {
        setfirstDate(undefined);
      }
    } catch (error) {
      // console.log(error);
    }
  };

  const selectedDateLast = (event) => {
    try {
      // console.log("selectedDateLast: ", event);

      const date = moment(event.value).format("DD/MM/YYYY");
      if (date) {
        setlastDate(event.value);
        // console.log("setlastDate: ", date);
      } else {
        setlastDate(undefined);
      }
    } catch (error) {
      // console.log(error);
    }
  };

  const calculateDividend = () => {
    let postdata = {
      firsData: firstDate,
      lastdate: lastDate,
      security: securitySelectItem,
      benchmark: sourceSelectItem,
      initialInvestment: initialInvestment,
      startingQuantity: startingQuantity,
    };
  };
  //#endregion



  //#region SERVICE API CALL 

  const getSharesSecurityOptions = () => {
    try {
      const culture = language;
      token
      dashboardServiceApi.yieldcalculatorSharesGet(token, culture).then((response) => {
        
        if (response.data) {
          setDropdownAllOption(response.data);
          setDropdownFilterOption(response.data);
        }
      });
    } catch (error) {
      console.log("getSharesSecurityOptions error: ", error);
    }
  }

  //#endregion SERVICE API CALL

  return (
    <div className="row m-t-15" id="DividendCalculator">
      <Row>
        <LiveTickerBar />
      </Row>
      <Row className="m-t-15">
        <h1 className="roboto-bold-24 pageHeader">{t('dividend.dividendCalculator.title')}</h1>
      </Row>
      <Row className="m-0 m-b-10">

        <Col className="p-0" md="9">
          <Row>
            <Col md="4">
              <label className="inputLabel"></label>
              <Dropdown data-bs-theme="dark" id="source-dropdown" className="custom-dropdown">
                <Dropdown.Toggle variant="secondary">{securitySelectItem.Name}</Dropdown.Toggle>
                <Dropdown.Menu>
                  <InputGroup className="dropdown-search-input-group mx-auto m-b-5 p-l-10 p-r-10">
                    <InputGroup.Text id="inputGroup-sizing-default">
                      <FontAwesomeIcon icon={faSearch} />
                    </InputGroup.Text>
                    <FormControl type="text" placeholder="Sembol/Hisse Ara..." onChange={(e) => handleSearchChange(e)} className="dropdownSearch" value={dropdownSearchValue} />
                  </InputGroup>
                  <div className="dropdown-scroll-menu">
                    {dropdownFilterOption.map((item, index) => (
                      <Dropdown.Item key={index} onClick={(e) => changeSecurityValue(item)} className={item.UniqueCode === securitySelectItem.UniqueCode ? "comboActiveItem" : ""}>
                        {item.Name}
                        <FontAwesomeIcon icon={faHexagonCheck} />
                      </Dropdown.Item>
                    ))}
                  </div>
                </Dropdown.Menu>
              </Dropdown>
            </Col>
            <Col md="4" className="p-l-0">
              <div className="p-r-15">
                <label className="inputLabel">Başlangıç Yatırımı</label>
                <InputText type="text" className="initial-investment" placeholder="Başlangıç Yatırımı" value={initialInvestment} onChange={(e) => setInitialInvestment(e.target.value)} />
              </div>
              <span className="orSpan">veya</span>
            </Col>

            <Col md="4" className="p-r-0">
              <div className="p-l-15">
                <label className="inputLabel">Başlangıç Adeti</label>
                <InputText type="text" className="starting-quantity" placeholder="Başlangıç Adeti" value={startingQuantity} onChange={(e) => setStartingQuantity(e.target.value)} />
              </div>
            </Col>
          </Row>
          <Row className="MultipleDatePicker">
            <Col md="3">
              <div className="">
                <label className="inputLabel">Başlangıç Tarihi</label>
                <Calendar value={firstDate} onChange={(event) => selectedDate(event)} dateFormat="dd-mm-yy" locale="tr" showIcon />
              </div>
            </Col>
            <Col md="3">
              <div className="">
                <label className="inputLabel">Bitiş Tarihi</label>
                <Calendar value={lastDate} onChange={(event) => selectedDateLast(event)} dateFormat="dd-mm-yy" locale="tr" showIcon />
              </div>
            </Col>
            <Col md="4">
              <label className="inputLabel">Kıstas</label>
              <Dropdown data-bs-theme="dark" id="source-dropdown" className="custom-dropdown">
                <Dropdown.Toggle variant="secondary">{sourceSelectItem.name}</Dropdown.Toggle>
                <Dropdown.Menu>
                  {sourceItems.map((item, index) => (
                    <Dropdown.Item key={index} onClick={(e) => changeValue(item)} className={item.id === sourceSelectItem.id ? "comboActiveItem" : ""}>
                      {item.name}
                      <FontAwesomeIcon icon={faHexagonCheck} />
                    </Dropdown.Item>
                  ))}
                </Dropdown.Menu>
              </Dropdown>
            </Col>
          </Row>
        </Col>
        <Col md="3" className="calculateBtnDiv">
          <Button slot="end" variant="dark" className="calculateBtn" onClick={(e) => calculateDividend()}>
            <FontAwesomeIcon icon={faCalculator} />
            HESAPLA
          </Button>
        </Col>
      </Row>
      <Row className="m-0">
        <wjcGrid.FlexGrid className="p-0" isReadOnly={true} initialized={initializeGrid.bind(this)} itemsSource={gridData} headersVisibility="Column" selectionMode="None" childItemsPath={["childsItem"]}>
          {gridColumns.map((item, index) => (
            <wjcGrid.FlexGridColumn
              key={index}
              align={item.align !== undefined ? item.align : ""}
              allowResizing={false}
              header={item.header}
              binding={item.binding}
              format={item.format !== undefined ? item.format : ""}
              isContentHtml={item.isContentHtml !== undefined ? item.isContentHtml : false}
              width={item.width !== undefined ? item.width : "*"}
              cssClass={item.cssClass !== undefined ? item.cssClass : ""}
            ></wjcGrid.FlexGridColumn>
          ))}
        </wjcGrid.FlexGrid>
      </Row>

      <Row className="m-0 m-t-40">
        <Col md="12" className="p-0 chartHeader">
          <h6>10.000,00$ Büyüme Temettüler Yeniden Yatırıldı.</h6>
        </Col>

        <Col md="12" className="p-0">
          <div className="p-0 ">
            <div id="chartdiv" style={{ width: "100%", height: "492px" }}></div>
          </div>
        </Col>
      </Row>
    </div>
  );
}
